<template>
	<div :style="outerContainerStyles">
		<div v-if="center" :style="centeringStyles">
			<slot>
				<div class="spinner">
					<div class="cube1"></div>
					<div class="cube2"></div>
				</div>
			</slot>
		</div>
		<slot v-else>
			<div class="spinner">
				<div class="cube1"></div>
				<div class="cube2"></div>
			</div>
		</slot>
	</div>
</template>

<script>
	export default {
		name: 'CElementCover',
		props: {
			boundaries: Array,
			center: {
				type: Boolean,
				default: true,
			},
			opacity: {
				type: Number,
				default: 0.4,
			},
		},
		components: {},
		data() {
			return {
				containerCoords: {
					top: 0,
					bottom: 0,
					left: 0,
					right: 0,
				},
				parentCoords: null,
			};
		},
		mounted() {
			if (this.boundaries) {
				this.setOffsets();
			}
		},
		computed: {
			outerContainerStyles() {
				return {
					...this.containerCoords,
					position: 'absolute',
					'background-color': `rgb(255,255,255,${this.opacity})`,
				};
			},
			centeringStyles() {
				return {
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translateX(-50%) translateY(-50%)',
				};
			},
		},
		methods: {
			setOffsets() {
				const parent = this.$el.parentElement;
				this.parentCoords = parent.getBoundingClientRect();
				this.boundaries.forEach(({ sides, query }) => {
					const element = parent.querySelector(query);
					if (!element || !sides) {
						return;
					}
					const coords = element.getBoundingClientRect();
					sides.forEach(side => {
						const sideMargin = Math.abs(coords[side] - this.parentCoords[side]);
						this.containerCoords[side] = sideMargin + 'px';
					});
				});
			},
		},
	};
</script>

<style scoped>
	/** SPINNER CSS */
	.spinner {
		margin: 40px auto;
		width: 40px;
		height: 40px;
		position: relative;
	}

	.cube1,
	.cube2 {
		background-color: #333;
		width: 15px;
		height: 15px;
		position: absolute;
		top: 0;
		left: 0;

		-webkit-animation: sk-cubemove 1.8s infinite ease-in-out;
		animation: sk-cubemove 1.8s infinite ease-in-out;
	}

	.cube2 {
		-webkit-animation-delay: -0.9s;
		animation-delay: -0.9s;
	}

	@-webkit-keyframes sk-cubemove {
		25% {
			-webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);
		}
		50% {
			-webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);
		}
		75% {
			-webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
		}
		100% {
			-webkit-transform: rotate(-360deg);
		}
	}

	@keyframes sk-cubemove {
		25% {
			transform: translateX(42px) rotate(-90deg) scale(0.5);
			-webkit-transform: translateX(42px) rotate(-90deg) scale(0.5);
		}
		50% {
			transform: translateX(42px) translateY(42px) rotate(-179deg);
			-webkit-transform: translateX(42px) translateY(42px) rotate(-179deg);
		}
		50.1% {
			transform: translateX(42px) translateY(42px) rotate(-180deg);
			-webkit-transform: translateX(42px) translateY(42px) rotate(-180deg);
		}
		75% {
			transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
			-webkit-transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
		}
		100% {
			transform: rotate(-360deg);
			-webkit-transform: rotate(-360deg);
		}
	}
</style>
